import i18n from '../i18n';

export default {
  zeroInt: '',
  all: i18n.t('constants.interiors.all'),
  chernInt: i18n.t('constants.interiors.chernInt'),
  chistInt: i18n.t('constants.interiors.chistInt'),
  whiteBox: i18n.t('constants.interiors.whiteBox'),
  repair: i18n.t('constants.interiors.repair'),
  predChistInt: i18n.t('constants.interiors.predChistInt'),
  remInt: i18n.t('constants.interiors.remInt'),
  chastRemInt: i18n.t('constants.interiors.chastRemInt')
};



// WEBPACK FOOTER //
// ./src/constants/interiors.js